import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { authApi } from '../lib/api/auth';
import { useAuth } from '../features/auth/AuthContext';
import { disablePush } from '../features/push/push';
import { usePushSync } from '../features/push/usePush';

const NAV_ITEMS = [
  { to: '/licitacoes', label: 'Licitações' },
  { to: '/filtros', label: 'Filtros' },
  { to: '/notificacoes', label: 'Notificações' },
  { to: '/estatisticas', label: 'Estatísticas' },
  { to: '/assinatura', label: 'Assinatura' },
  { to: '/conta', label: 'Conta' },
];

export function AppLayout() {
  const { user } = useAuth();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  usePushSync();
  const logout = useMutation({
    // Stop pushes to this browser first, while the session still exists to authorize the DELETE.
    mutationFn: async () => {
      await disablePush();
      await authApi.logout();
    },
    // Explicit redirect — never rely on RequireAuth reacting to the cache clear on its own
    // (it eventually would, but only once the "me" query happens to re-run and 401).
    onSettled: () => {
      queryClient.clear();
      navigate('/entrar', { replace: true });
    },
  });

  return (
    <div className="min-h-screen bg-bg">
      <header className="border-b border-line bg-surface">
        <div className="mx-auto flex max-w-[1120px] flex-wrap items-center justify-between gap-4 px-4 py-3">
          <div className="flex items-center gap-2">
            <img src="/assets/img/favicon.svg" alt="" className="h-7 w-7" aria-hidden="true" />
            <span className="font-display text-lg font-semibold text-ink">Licitavia</span>
          </div>
          <nav aria-label="Principal" className="flex flex-wrap gap-1">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `min-h-11 rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                    isActive ? 'bg-brand-50 text-brand-700' : 'text-ink-2 hover:bg-surface-2'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            <span className="hidden text-sm text-muted sm:inline">{user?.company.name}</span>
            <button
              type="button"
              onClick={() => logout.mutate()}
              disabled={logout.isPending}
              className="min-h-11 rounded-full border border-ink px-4 py-2 text-sm font-medium text-ink hover:bg-surface-2 disabled:opacity-50"
            >
              Sair
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-[1120px] px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
